import { useEffect, useState } from "react";
import { _BudgetID } from "../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import { InputDate } from "../theme/Input/InputDate";
import { PrintJson } from "../theme/Component/PrintJson";
import { SelectorDocumentFactory } from "../contabilidad/bodegaDocumentos/SelectorDocumentFactory";
import { BasicButton } from "../theme/Component/BasicButton";
import { ListMenu } from "../theme/Component/ListMenu";
import useModal, { MODAL_XL } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import { VisorDocumentFactory } from "../documents/VisorDocumentFactory";
import { YearSelector } from "../../core/shared/inputs/YearSelector";

interface Props{
    year:number;    
    budget:string;
    
}
export const DetailBudget=({year,budget}:Props)=>{

    const _budgetID = useDataBean(_BudgetID);
    const {lista,setLista,bean,setBean,instance,handleChange} = _budgetID;
    const [filter,setFilter] = useState<any>({
        Value:">0",
        BudgetIDStr:budget,
        IDAdquisitionItem:4488
    });
   const modalDocumento = useModal("Documento",MODAL_XL);

    useEffect(()=>{
        // if(filter.Mnemonic)
        // {

        // }else{

        // }
        
    },[])

    const getDocuments =()=>{
        instance.getListBudgetDocumentByProps(1,1000,year,filter.Mnemonic,filter,filter.FromDate,filter.UptoDate).then(
            (resp:any)=>{
                setLista(resp.List);
            }
        )
    }

    const head = [
        {title:'ID',property:'IDDocument',visible:false,mask:MASK_NUMBER},
        {title:'Nemonico',property:'Mnemonic',visible:true},
        {title:'Consecutivo',property:'Consecutive',visible:true,mask:MASK_NUMBER},
        {title:'Consecutivo Ext.',property:'ExternalReference',visible:true,mask:MASK_NUMBER},
        {title:'Fecha',property:'DocumentDate',visible:true,mask:MASK_DATE},
        {title:'Rubro',property:'BudgetIDStr',visible:true},
        {title:'Valor',property:'Value',visible:true,mask:MASK_MONEY},
              
    ]
    const listaBotones = () => {
           const botones = [
               { titulo: 'Ver Documento', icono: 'ri-file-add-line', visible: true, evento: () => { modalDocumento.open() } },
           ]
           return (
               <ListMenu listaBotones={botones} />
           )
       }

    return(
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-12">
                        <h5><strong>Rubro</strong> {budget}</h5>
                    </div>
                   
                    <div className="col-md-3">
                        <SelectorDocumentFactory label="Tipo Documento" onChange={(e)=>{setFilter({...filter,"Mnemonic":e.Mnemonic})}}/>
                    </div>
                    <div className="col-md-3">
                        <InputDate label="Desde" name="fromDate" value={filter.FromDate} setDate={(e)=>{setFilter({...filter,"FromDate":e})}}/>
                    </div>
                    <div className="col-md-3">
                        <InputDate label="Hasta" name="uptoDate" value={filter.UptoDate} setDate={(e)=>{setFilter({...filter,"UptoDate":e})}}/>
                    </div>
                    <div className="col-md-12 mt-2">
                        <BasicButton icon="" eventClick={getDocuments}>Buscar</BasicButton>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <BasicTable head={head} body={lista} rowSet={setBean} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            <VisorDocumentFactory Consecutive={bean.Consecutive} Mnemonic={bean.Mnemonic}/>
                        </div>
                    </div>
                </Modal>
                {/* <PrintJson json={filter}/> */}
            </div>
        </div>
    )
}